import { render, staticRenderFns } from "./CustomRequestsNew.vue?vue&type=template&id=7b01ecd7&scoped=true"
import script from "./CustomRequestsNew.vue?vue&type=script&lang=ts"
export * from "./CustomRequestsNew.vue?vue&type=script&lang=ts"
import style0 from "./CustomRequestsNew.vue?vue&type=style&index=0&id=7b01ecd7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b01ecd7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b01ecd7')) {
      api.createRecord('7b01ecd7', component.options)
    } else {
      api.reload('7b01ecd7', component.options)
    }
    module.hot.accept("./CustomRequestsNew.vue?vue&type=template&id=7b01ecd7&scoped=true", function () {
      api.rerender('7b01ecd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companyContractors/CustomRequestsNew.vue"
export default component.exports